module.exports = __webpack_public_path__ + "img/vu.730801ab.svg";